<div class="section bdr-full-overview-section">
  <span class="bold">Full Overview</span>
  <span class="bdr-full-overview-text" innerHTML="{{ comparable.fullOverviewEN ? comparable.fullOverviewEN : 'N/A' }}"></span>
</div>
<div class="section">
  <span class="bold">Trade Description</span>
  <span innerHTML="{{ comparable.tradeDescEN ? comparable.tradeDescEN : 'N/A' }}"></span>
</div>
<div class="section">
  <span class="bold">Native Language Translated</span>
  <span innerHTML="{{ comparable.tradeDescTranslated ? comparable.tradeDescTranslated : 'N/A' }}"></span>
</div>
<div class="section">
  <span class="bold">Other Language</span>
  <span innerHTML="{{ comparable.tradeDescNL ? comparable.tradeDescNL : 'N/A' }}"></span>
</div>
<div class="row">
  <div class="col-4 section">
    <span class="bold">ID Number</span>
    <span>{{ comparable.bvDId }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Country</span>
    <span>{{ comparable.countryName }}</span>
  </div>
  <div class="col-4 section">
    <span class="bold">Website</span>
    <span
      ><a class="website" href="{{ comparable?.companyWebSite | hyperLink }}" rel="noopener noreferrer" target="_blank">{{
        comparable.companyWebSite
      }}</a></span
    >
  </div>
</div>
